export default __webpack_public_path__ + "static/media/Group 2661@2x.beb6aa9b.png";